// ========== plugin import =========== //
import React,{useEffect, useState, useRef} from 'react'
import { Link, useLocation  } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { faRocketchat  } from '@fortawesome/free-brands-svg-icons';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { values } from 'lodash';
import axios from 'axios'
import { useSelector } from 'react-redux';
// import { toast } from 'react-toastify';
// ========== component import =========== //
import AlertMessage from '../../../../component/common/AlertMessage';
import ButtonLoader from '../../../../component/common/ButtonLoader';
import { refreshCaptcha } from '../../../../component/common/Helper';
import { countryCodeList } from '../../../../constants/selectOptions';




const Contact = () => {
    const api_base_url = process.env.REACT_APP_API_URL;
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [pathname]);

    // ------- define all state ------- //
    const [ formSubmitRes, setFormSubmitRes ] = useState('');
    return (
        <>
            <section className="hero-area hero-area-background">
                <div className="container">
                    <div className="text-center px-20">
                        <div className="section-heading">
                            <div className="title-wrapper">
                                <h2 className="section-title has_fade_anim fs-4x  text-grad-1 pb-6">
                                    Contact Us
                                </h2>
                            </div>
                            <div className="text-wrapper mt-0">
                                <p className="text has_fade_anim mt-3 fs-1  text-grad-3">
                                    We’d love to talk to you. After all, we are in the business of conversations.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="container p-0">
                    <div className='row mt-20'>
                        <div className="col-md-4">
                            <div className="text-center bg-light-info card-rounded d-flex flex-column justify-content-center p-10 h-100">
                                <span className="svg-icon svg-icon-3tx svg-icon-primary">
                                    <FontAwesomeIcon icon={faRocketchat} />
                                </span>
                                <h4 className="text-dark fw-bold my-5">
                                    Chat with us
                                </h4>
                                <p className="text-gray-700 fs-3 fw-semibold">
                                    We've got live Social Experts waiting to help you <span className='fw-bold'>monday to friday</span>  from <span className='fw-bold'>9am to 5pm IST</span>.
                                </p>
                                <div className="mt-auto pt-5">
                                    <Link to="#" className="wc-btn wc-btn-primary_1 btn-text-flip w-100">
                                        <span data-text="Chat with us">
                                            Chat with us
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="text-center bg-light-info card-rounded d-flex flex-column justify-content-center p-10 h-100">
                                <span className="svg-icon svg-icon-3tx svg-icon-primary">
                                    <FontAwesomeIcon icon={faEnvelope} />
                                </span>
                                <h4 className="text-dark fw-bold my-5">
                                    Email Us
                                </h4>
                                <p className="text-gray-700 fs-3 fw-semibold">
                                    Simple drop us an email at <span className='fw-bold'>sales@truvoice.in</span> and you'll receive a reply within 24 hours
                                </p>
                                <div className="mt-auto pt-5">
                                    <Link to="#" className="wc-btn wc-btn-primary_1 btn-text-flip w-100">
                                        <span data-text="Email Us">Email Us</span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="text-center bg-light-info card-rounded d-flex flex-column justify-content-center p-10 h-100">
                                <span className="svg-icon svg-icon-3tx svg-icon-primary">
                                    <FontAwesomeIcon icon={faPhone} />
                                </span>
                                <h4 className="text-dark fw-bold my-5">
                                    Give us a call
                                </h4>
                                <p className="text-gray-700 fs-3 fw-semibold">
                                    Give us a ring. Our Experts are standing by <span className='fw-bold'>Monday to Friday</span>  from <span className='fw-bold'>9am to 5pm IST</span>.
                                </p>
                                <div className="mt-auto pt-5">
                                    <Link to="#" className="wc-btn wc-btn-primary_1 btn-text-flip w-100">
                                        <span data-text="+91 40 48566077 ">+91 40 48566077 </span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row mt-20 border p-10 custom-card-bg br-20'>
                        <div className='col-md-12'>
                            <div className='text-center'>
                                <h2 className="section-title fs-3x text-grad-3">
                                    Get in Touch
                                </h2>
                                <p className="text my-3 pe-5 fs-3 text-gray-700">
                                    Have a question or just want to say hello? Drop us a message!
                                </p>
                            </div>
                            <Formik
                                initialValues={{ 
                                    inp_name: '', 
                                    inp_email: '', 
                                    inp_phone: '',
                                    country_code:'',
                                    inp_organization: '',
                                    inp_designation: '',
                                    select_works: '',
                                    inp_comments: '',
                                    terms_and_conditions: false
                                }}
                                validate={values => {
                                    const errors = {};
                                    if (!values.inp_name) {
                                        errors.inp_name = 'Name is required';
                                    }
                                    if (!values.inp_email) {
                                        errors.inp_email = 'Email is required';
                                    }
                                    else if(!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.inp_email)){
                                        errors.inp_email = 'Invalid email address';
                                    }
                                    if (!values.inp_phone) {
                                        errors.inp_phone = 'Phone no is required';
                                    }
                                    else if(!/^\d{10}$/.test(values.inp_phone)){
                                        errors.inp_phone = 'Invalid mobile no';
                                    }
                                    if(!values.country_code){
                                        errors.country_code = 'Country code is required';
                                    }
                                    if (!values.inp_organization) {
                                        errors.inp_organization = 'Organization is required';
                                    }
                                    if (!values.inp_designation) {
                                        errors.inp_designation = 'Designation is required';
                                    }
                                    if (!values.select_works) {
                                        errors.select_works = 'Works is required';
                                    }
                                    if (!values.inp_comments) {
                                        errors.inp_comments = 'Comments is required';
                                    }
                                    if (!values.terms_and_conditions) {
                                        errors.terms_and_conditions = 'Accepting the Terms and Conditions is required.';
                                    }
                                    return errors;
                                }}
                                onSubmit={async (formValues, { setSubmitting, resetForm  }) => {
                                    const api_headers = {
                                        headers: { 
                                            "Content-Type": "application/json",
                                            "Accept": "application/json",
                                        }
                                    };
                                    const newCap = await refreshCaptcha();
                                    formValues.capchaToken = newCap
                                    try{
                                        await axios.post(`${api_base_url}api/save-contact-info`, formValues, api_headers)
                                        .then(async (res) => {
                                            if(res.data.status === 'success') {
                                                setFormSubmitRes('success');
                                            } else if(res.data.status === 'error') {
                                                setFormSubmitRes('error');
                                            }
                                        })
                                        .catch((error) => {
                                            console.error(error);
                                        })
                                    }
                                    catch(e){
                                        console.error(e);
                                    }
                                    finally {
                                        setSubmitting(false);
                                        resetForm();
                                    }
                                }}
                            >
                                {({ isSubmitting }) => (
                                    <Form autoComplete="off">
                                        <div className='row'>
                                            <div className='col-md-6'>
                                                <div className="form-floating mb-7">
                                                    <Field type="text" className="form-control" id="inp_name" placeholder="Name" autoComplete="new-password" name="inp_name"/>
                                                    <label htmlFor="inp_name" className='fs-4'>Name</label>
                                                    <ErrorMessage name="inp_name" component="div" className="text-danger mt-2" />
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className="form-floating mb-7">
                                                    <Field type="text" className="form-control" id="inp_email" placeholder="Email" autoComplete="new-password" name="inp_email"/>
                                                    <label htmlFor="inp_email" className='fs-4'>Email</label>
                                                    <ErrorMessage name="inp_email" component="div" className="text-danger mt-2" />
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className="form-floating">
                                                    <Field as="select" className="form-select" id="country_code" aria-label="Floating label select example" name="country_code">
                                                        <option value="">Select country code</option>
                                                        {countryCodeList.map((item, index) => (
                                                            <option key={index} value={item.value}>
                                                                {item.label}
                                                            </option>
                                                        ))}
                                                    </Field >
                                                    <label htmlFor="country_code" className='fs-4'>Works with selects</label>
                                                    <ErrorMessage name="country_code" component="div" className="text-danger mt-2" />
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className="form-floating mb-7">
                                                    <Field 
                                                        type="text" 
                                                        className="form-control" 
                                                        id="inp_phone" 
                                                        placeholder="Phone" 
                                                        autoComplete="new-password" 
                                                        name="inp_phone"
                                                        onKeyPress={(e) => {
                                                            if (!/[0-9]/.test(e.key)) {
                                                              e.preventDefault();
                                                            }
                                                        }}
                                                    />
                                                    <label htmlFor="inp_phone" className='fs-4'>Phone</label>
                                                    <ErrorMessage name="inp_phone" component="div" className="text-danger mt-2" />
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className="form-floating mb-7">
                                                    <Field type="text" className="form-control" id="inp_organization" placeholder="Organization" autoComplete="new-password" name="inp_organization"/>
                                                    <label htmlFor="inp_organization" className='fs-4'>Organization</label>
                                                    <ErrorMessage name="inp_organization" component="div" className="text-danger mt-2" />
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className="form-floating mb-7">
                                                    <Field type="text" className="form-control" id="inp_designation" placeholder="Designation" autoComplete="new-password" name="inp_designation"/>
                                                    <label htmlFor="inp_designation" className='fs-4'>Designation</label>
                                                    <ErrorMessage name="inp_designation" component="div" className="text-danger mt-2" />
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className="form-floating">
                                                    <Field as="select" className="form-select" id="select_works" aria-label="Floating label select example" name="select_works">
                                                        <option value="">Select an option</option>
                                                        <option value="TruVoice.ai">
                                                            TruVoice.ai
                                                        </option>
                                                        <option value="Template BOT">
                                                            Template BOT
                                                        </option>
                                                        <option value="Automated NLU Training">
                                                            Automated NLU Training
                                                        </option>
                                                        <option value="Custom-built AI BOTs">
                                                            Custom-built AI BOTs
                                                        </option>
                                                        <option value="NLG Service">
                                                            NLG Service
                                                        </option>
                                                        <option value="NLP,AI,ML Services">
                                                            NLP,AI,ML Services
                                                        </option>
                                                        <option value="Data Science Services">
                                                            Data Science Services
                                                        </option>
                                                        <option value="Others">
                                                            Others
                                                        </option>
                                                    </Field >
                                                    <label htmlFor="select_works" className='fs-4'>Works with selects</label>
                                                    <ErrorMessage name="select_works" component="div" className="text-danger mt-2" />
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className="form-floating">
                                                    <Field as="textarea" className="form-control" placeholder="Leave a comment here" id="floatingTextarea2" name="inp_comments"></Field >
                                                    <label htmlFor="floatingTextarea2" className='fs-4'>Comments</label>
                                                    <ErrorMessage name="inp_comments" component="div" className="text-danger mt-2" />
                                                </div>
                                            </div>
                                            <div className='col-md-8 mt-7'>
                                                <div className="form-check form-check-solid mt-3">
                                                    <Field as="input" type="checkbox" className="form-check-input bg-dark" value={values.terms_and_conditions} id="terms_conditional_details" name="terms_and_conditions" />
                                                    <label className="form-check-label mt-1 text-gray-700" htmlFor="terms_conditional_details">
                                                        I agree to TruVoice's Terms & Conditions of Use and Privacy Policy.
                                                    </label>
                                                    <ErrorMessage name="terms_and_conditions" component="div" className="text-danger mt-2" />
                                                </div>
                                            </div>
                                            <div className='col-md-4 text-end mt-7'>
                                                <button 
                                                    className='btn btn-dark btn-lg' 
                                                    type="submit" 
                                                    disabled={isSubmitting}
                                                >
                                                    {
                                                        isSubmitting ? <ButtonLoader btnHtml='Please wait...' className='me-2'/> : 'Submit'
                                                    }
                                                </button>
                                            </div>
                                            <div className='col-md-12 mt-5'>
                                                {
                                                    formSubmitRes === 'success' &&
                                                    <AlertMessage
                                                        type = {`success`}
                                                        title = {`Thank you for contacting us.`}
                                                        sub_title = {`We’ve received your message and will respond as soon as possible.`}
                                                        border_type='dashed'
                                                    />
                                                }
                                                {
                                                    formSubmitRes === 'error' &&
                                                    <AlertMessage
                                                        type = {`danger`}
                                                        title = {`Error`}
                                                        sub_title = {`There is an error`}
                                                        border_type='dashed'
                                                    />
                                                }
                                            </div>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export {Contact}